import { BalanceReport } from '@src/pages/ticketRestaurant/index';

const BalanceMarketReport = () => {
  return <BalanceReport isMarket={true} />;
};

export default BalanceMarketReport;
